// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Marketing from '../Marketing';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    information: state.ui.storeInformation,
    isFetchingStoreInformation: state.ui.isFetchingStoreInformation,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(Marketing);
